/** @format */

import { Button, Col, Form, Input, Row } from "antd";
import {
  UserOutlined,
  LockOutlined,
  EyeTwoTone,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import React, { useState } from "react";

interface IProps {
  disableLogIn: boolean;
  onClickLogIn: () => Promise<string>;
  email?: string;
  onChangeEmail: (value: string) => void;
  onChangePassword: (value: string) => void;
  password?: string;
}

const LoginFormView: React.FC<IProps> = (props) => {
  const [form] = Form.useForm();

  const [errorMessages, setErrorMessages] = useState<string>("");

  async function handleSubmit() {
    const loginResponse = await props.onClickLogIn();
    if (loginResponse !== "success") {
      setErrorMessages(loginResponse);
    }
  }

  return (
    <Form form={form} onFinish={handleSubmit}>
      <Row>
        <Col>
          <Row>
            <Col style={{ width: "100%" }}>
              <Form.Item>
                <Input
                  autoComplete="email"
                  onChange={(e) => {
                    setErrorMessages("");
                    props.onChangeEmail(e.target.value);
                  }}
                  placeholder="Email"
                  prefix={<UserOutlined style={{ opacity: 0.25 }} />}
                  value={props.email}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Item>
                <Input.Password
                  autoComplete="current-password"
                  onChange={(e) => {
                    setErrorMessages("");
                    props.onChangePassword(e.target.value);
                  }}
                  placeholder="Password"
                  prefix={<LockOutlined style={{ opacity: 0.25 }} />}
                  iconRender={(visible) =>
                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                  }
                  value={props.password}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Item>
                <Button
                  disabled={errorMessages !== ""}
                  block
                  /* disabled={props.disableLogIn} */
                  htmlType="submit"
                  type="primary">
                  Log in
                </Button>
              </Form.Item>
            </Col>
          </Row>
          <Row
            style={{
              color: "red",
              fontSize: "13px",
              marginTop: "-15px",
            }}>
            {errorMessages}
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default LoginFormView;
